const BASE_URL = window.location.protocol + '//' + window.location.host;
export const API_URL_STRUCTURED_CONTENTS =  BASE_URL + '/o/headless-delivery/v1.0/sites/';
export const API_URL_SECRETARY =  BASE_URL + '/o/c/calendarsecretarios/scopes/';
export const ITEMS_PER_PAGE = 20;
